var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3.4585H4C3.58579 3.4585 3.25 3.79428 3.25 4.2085V6.4585C3.25 6.87271 3.58579 7.2085 4 7.2085H6.25C6.66421 7.2085 7 6.87271 7 6.4585V4.2085C7 3.79428 6.66421 3.4585 6.25 3.4585Z",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.4585H13.75C13.3358 3.4585 13 3.79428 13 4.2085V6.4585C13 6.87271 13.3358 7.2085 13.75 7.2085H16C16.4142 7.2085 16.75 6.87271 16.75 6.4585V4.2085C16.75 3.79428 16.4142 3.4585 16 3.4585Z",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13.2085H4C3.58579 13.2085 3.25 13.5443 3.25 13.9585V16.2085C3.25 16.6227 3.58579 16.9585 4 16.9585H6.25C6.66421 16.9585 7 16.6227 7 16.2085V13.9585C7 13.5443 6.66421 13.2085 6.25 13.2085Z",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 13.2085H14.5C14.1022 13.2085 13.7206 13.3665 13.4393 13.6478C13.158 13.9291 13 14.3107 13 14.7085V16.9585",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16.9585V16.966",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.4585V8.7085C10 9.10632 9.84196 9.48785 9.56066 9.76916C9.27936 10.0505 8.89782 10.2085 8.5 10.2085H6.25",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 10.2085H3.2575",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.4585H10.0075",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.2085V13.216",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.2085H13.75",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 10.2085V10.216",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.9585V16.2085",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.82eb17360e6f058ce6f90dedc4348cfd.svg";
export { ForwardRef as ReactComponent };